/**
 * @generated SignedSource<<c9d6ef0e810e0e7cf9ea91e808f0e2d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemTileCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemTileBase_viewer" | "ProductCarousel_viewer">;
  readonly " $fragmentType": "ItemTileCarousel_viewer";
};
export type ItemTileCarousel_viewer$key = {
  readonly " $data"?: ItemTileCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTileCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileCarousel_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTileBase_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "991889016f89db7178e658552399964f";

export default node;
